import React, {useEffect, useMemo, useRef, useState} from 'react';
import {defaultProps, adUnits} from "./config";
import Dfp from "../Dfp";
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const baseURL = document.querySelector('meta[name="baseURL"]').content;
const basePATH = document.querySelector('meta[name="basePATH"]').content;
const theme = document.querySelector('meta[name="theme"]') ? document.querySelector('meta[name="theme"]').content : basePATH.replace(baseURL+'/wp-content/themes/','');
const page = document.querySelector('meta[name="page"]').content;

const positions = Object.keys(defaultProps); // 'firstLeaderboard', 'firstMediumRectangle', 'loopLeaderboard', 'loopMediumRectangle', 'mobileSplashAd', 'inRead' or 'inPostAd'

/**
 * Yes, it's global....
 *
 * @param position {'firstLeaderboard'|'firstMediumRectangle'|'loopLeaderboard'|'loopMediumRectangle'|'mobileSplashAd'|'inRead'|'inPostAd'}
 * @param el {string|Element} The element object or it's id which the advert should be rendered in.
 */
window.renderAdvert = function renderAdvert (position, el) {
  if (typeof el === "string") { el = document.getElementById(el); }
  ReactDOM.render(<Advert position={position} />, el);
};

function newDfpKey () {
  return (+(new Date()));
}

const isSingle = !!document.querySelector("meta[name='page'][content='single']");

const isShemomSponsorAd = (() => {
  if (!document.querySelector("meta[name='theme'][content='shemom.com']")) { return false; }
  const catIdTag = document.querySelector("meta[name='catId']");
  if (catIdTag instanceof Element && ["7287", "7289", "7338", "7339"].includes(catIdTag.content)) { return true; }
  return false;
})();

/**
 * As the advert functionality has been hard to use and WET, I am going to make
 * it all-in-one.
 *
 * #dontrepeatyourself
 *
 * @author winghim.liu@team.she.com
 *
 * Here's the example of how to use it.
 * @example
 * <Advert dftReady={dftReady} dftUpdate={dftUpdate} position="firstLeaderboard" />
 * <Advert dftReady={dftReady} dftUpdate={dftUpdate} position="loopLeaderboard" />
 *
 * Enhancement 20211118: when the user is holding the ad on the page for a
 * while (10 sec), it will refresh automatically.
 * Conditions in detail:
 *  - If the ad is visible on screen for 10 secs, it reloads.
 *  - If the ad has more than 50% NOT visible on screen, it WON'T load.
 *  - If the user has scrolled for a whole page height in article page and the
 *    ad is visible, the medium rectangle ad reloads.
 */
export default function Advert (props) {
	const {position, ...restProps} = props;
  const [dfpKey, setDfpKey] = useState(newDfpKey);
	const adUnit = useMemo(() => {
		try { return adUnits[theme][page !== "none" ? page : "home"][position]; }
		catch (ex) { return null; }
	}, [position]);
  const dfpRef = useRef();

	useEffect(() => {
		if (["firstLeaderboard", "firstMediumRectangle", "loopLeaderboard", "loopMediumRectangle"].includes(position) && !isShemomSponsorAd) {
      let isVisible;
      let refreshTimeoutId = null;
      const lastRefreshPoint = document.documentElement.scrollTop;

      function refreshAd () {
        setDfpKey(newDfpKey);
      }

      function startRefreshTimeout () {
        if (refreshTimeoutId === null) {
          refreshTimeoutId = window.setTimeout(refreshAd, 10000);
        }
      }

      function stopRefreshTimeout () {
        if (typeof refreshTimeoutId === "number") {
          window.clearTimeout(refreshTimeoutId);
          refreshTimeoutId = null;
        }
      }

      function restartRefreshTimeout () {
        stopRefreshTimeout();
        startRefreshTimeout();
      }

      function updateIsVisible () {
        const {top, left, width, height} = dfpRef.current.getBoundingClientRect();

        /**
         * Check if the advert element has at least 50% of it's surface showing
         * on screen by checking the element's center point.
         */
        const pointedElement = document.elementFromPoint(left + width / 2, top + height / 2);
        return isVisible = (element => {
          for (;;) {
            if (element === dfpRef.current) { return true; }
            if (element === document.body || !element) { return false; }
            element = element.parentNode;
          }
          return false;
        })(pointedElement);
      }

      function onScroll () {
        updateIsVisible();
        if (isVisible) {
          if (isSingle && ["firstMediumRectangle", "loopMediumRectangle"].includes(position) && Math.abs(lastRefreshPoint - document.documentElement.scrollTop) > (window.innerHeight << 1)) {
            refreshAd();
          } else {
            startRefreshTimeout();
          }
        }
        else {
          stopRefreshTimeout();
        }
      }

      function onMouseMove (event) {
        if (isVisible) { restartRefreshTimeout(); }
      }

      if (dfpRef.current instanceof Element) {
        updateIsVisible();
        window.addEventListener("scroll", onScroll);
        dfpRef.current.addEventListener("mousemove", onMouseMove);
      }
      startRefreshTimeout();

      return () => {
        stopRefreshTimeout();
        window.removeEventListener("scroll", onScroll);
        dfpRef.current.removeEventListener("mousemove", onMouseMove);
      };
    }
	}, [dfpRef.current, position]);

	if (!position || adUnit === null) { return null; }
	return (
		<Dfp
      key={dfpKey}
			{...defaultProps[position]}
			adUnit={adUnit}
      dfpRef={dfpRef}
			theme={theme}
			page={page}
			position={position}
			{...restProps}
		/>
	);
}

Advert.propTypes = {
	callback: PropTypes.func,
	dfpReady: PropTypes.func,
	dfpUpdate: PropTypes.func,
	position: PropTypes.oneOf(positions).isRequired,
};



// WEBPACK FOOTER //
// ./src/Advert/index.js